import { Box, Flex, rem, Skeleton, Text } from "@mantine/core";
import { NOTIFICATION_SOUND_RULES } from "../../constants";
import { NotificationSoundHeader } from "./NotificationSoundHeader";
import classes from "./index.module.css";

/**
 * Esqueleto da aba Notificações (fallback do chunk). Título, descrição e os
 * textos das situações são fixos e já aparecem reais; só as caixas, o status e
 * o botão (que dependem da preferência) viram esqueleto.
 */
export function NotificationSoundTabSkeleton() {
  return (
    <Flex
      direction="column"
      gap={rem(24)}
      className={classes.root}>
      <Flex
        direction="column"
        gap={rem(12)}>
        <NotificationSoundHeader />
        <Flex
          direction="column"
          gap={rem(12)}
          className={classes.rules}>
          {NOTIFICATION_SOUND_RULES.map((rule) => (
            <Flex
              key={rule.key}
              gap={rem(12)}
              align="flex-start">
              <Box className={classes.ruleCheckbox}>
                <Skeleton
                  h={rem(20)}
                  w={rem(20)}
                  radius="sm"
                />
              </Box>
              <Box miw={0}>
                <Text className={classes.ruleLabel}>{rule.label}</Text>
                <Text className={classes.ruleHint}>{rule.hint}</Text>
              </Box>
            </Flex>
          ))}
        </Flex>
        <Skeleton
          h={rem(16)}
          w={rem(220)}
          radius="sm"
        />
      </Flex>
      <Skeleton
        h={rem(36)}
        w={rem(126)}
        radius="sm"
      />
    </Flex>
  );
}

export default NotificationSoundTabSkeleton;
